import { useEffect, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { isNonAdjacentBannerSlide } from './bannerSlideJump'

type useBannerRowScrollTransitionProps = {
  infiniteLoop: boolean
  activeSlide: number
  visibleCards: number
  setActiveSlide: (prop: number) => void
  length: number
}

export const useBannerRowScrollTransition = ({
  infiniteLoop,
  activeSlide,
  visibleCards,
  setActiveSlide,
  length,
}: useBannerRowScrollTransitionProps) => {
  const [scrollEnabled, setScrollEnabled] = useState<boolean>(false)
  const pendingEnableFrame = useRef<number | null>(null)

  // Hack to prevent initial banner scrolling to target activeSlide
  const [isMount, setIsMount] = useState<boolean>(false)

  const cancelPendingEnable = (): void => {
    if (pendingEnableFrame.current == null) return
    cancelAnimationFrame(pendingEnableFrame.current)
    pendingEnableFrame.current = null
  }

  const scheduleScrollEnable = (): void => {
    cancelPendingEnable()
    pendingEnableFrame.current = requestAnimationFrame(() => {
      pendingEnableFrame.current = requestAnimationFrame(() => {
        pendingEnableFrame.current = null
        setScrollEnabled(true)
      })
    })
  }

  useEffect(() => {
    setIsMount(true)
    return cancelPendingEnable
  }, [])

  useEffect(() => {
    const isEdgeActiveSlide =
      activeSlide === visibleCards || activeSlide === length
    if (isEdgeActiveSlide && isMount) {
      setScrollEnabled(true)
    }
  }, [activeSlide, visibleCards, length, isMount])

  const disableTransitionIfJump = (
    fromSlide: number,
    toSlide: number
  ): void => {
    if (!isNonAdjacentBannerSlide(fromSlide, toSlide)) return
    setScrollEnabled(false)
    scheduleScrollEnable()
  }

  const handleTransitionEnd = (): void => {
    flushSync(() => {
      if (infiniteLoop && activeSlide === 0) {
        setScrollEnabled(false)
        setActiveSlide(length)
      } else if (infiniteLoop && activeSlide === length + visibleCards) {
        setScrollEnabled(false)
        setActiveSlide(visibleCards)
      }
    })
  }

  return {
    scrollEnabled,
    handleTransitionEnd,
    disableTransitionIfJump,
  }
}
